// Appbar.js
import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";

const Appbar = ({ onMenuClick }) => {
  const navigate = useNavigate();

  return (
    <AppBar
      position="fixed"
      sx={{
        background: "linear-gradient(to right, #2A7B9B, #57C785, #2A7B9B)",
        color: "white",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* Left side */}
        <Box display="flex" alignItems="center" gap={2}>
          <IconButton
            color="inherit"
            edge="start"
            sx={{ display: { sm: "none" } }} // Only show on mobile
            onClick={onMenuClick}
          >
            <MenuIcon />
          </IconButton>

          <Box
            component="img"
            src="/Assets/TA logo.png"
            alt="Logo"
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1,
              bgcolor: "#fff",
              p: 0.5,
            }}
          />
          <Typography variant="h6" fontWeight="bold">
            Help Center
          </Typography>
        </Box>

        <Button color="inherit" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Appbar;
